export default {
      id: "help-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#help",
      toString: function () {
        return this.url;
      }
    }